import calendarDays from '../../assets/sales-report/calendar-days.svg'
import chartLine from '../../assets/sales-report/chart-line.svg'
import check from '../../assets/sales-report/check.svg'
import chevronDown from '../../assets/sales-report/chevron-down.svg'
import close from '../../assets/sales-report/close.svg'
import download from '../../assets/sales-report/download.svg'
import downloadLight from '../../assets/sales-report/download-light.svg'
import downloadMobile from '../../assets/sales-report/download-mobile.svg'
import file from '../../assets/sales-report/file.svg'
import gift from '../../assets/sales-report/gift.svg'
import printer from '../../assets/sales-report/printer.svg'
import printerMobile from '../../assets/sales-report/printer-mobile.svg'
import sliders from '../../assets/sales-report/sliders.svg'
import ticket from '../../assets/sales-report/ticket.svg'

export const salesReportIcons = {
  calendarDays,
  chartLine,
  check,
  chevronDown,
  close,
  download,
  downloadLight,
  downloadMobile,
  file,
  gift,
  printer,
  printerMobile,
  sliders,
  ticket,
}
